import { render, staticRenderFns } from "./BillingMaintenanceWarningBanner.vue?vue&type=template&id=4c0b7486"
import script from "./BillingMaintenanceWarningBanner.vue?vue&type=script&lang=js"
export * from "./BillingMaintenanceWarningBanner.vue?vue&type=script&lang=js"
import style0 from "./BillingMaintenanceWarningBanner.vue?vue&type=style&index=0&id=4c0b7486&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports